import * as z from 'zod';
import {validLicenses} from '@deskly/shared-ui/licensing';

export const featureFlagModel = z.object({
    enabled: z.boolean(),
});

export type FeatureFlag = z.infer<typeof featureFlagModel>;

export const licensedFeatureFlagModel = z.union([
    z.boolean(),
    z
        .string()
        .transform(val => val.split('|'))
        .transform(arr => validLicenses.filter(license => arr.includes(license))),
]);
export type LicensedFeatureFlag = z.infer<typeof licensedFeatureFlagModel>;

export const featureFlagResponseModel = z.record(z.string(), licensedFeatureFlagModel);
export type FeatureFlagResponse = z.infer<typeof featureFlagResponseModel>;
